import { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import VerifyEmailPage from './pages/VerifyEmailPage'
import AuthorCenter from './pages/AuthorCenter'
import AgentsPage from './pages/AgentsPage'
import AgentTeamPage from './pages/AgentTeamPage'
import WorkspacePage from './pages/WorkspacePage'
import ProfilePage from './pages/ProfilePage'
import UserMemoryPage from './pages/UserMemoryPage'
import SkillDocumentPage from './pages/SkillDocumentPage'
import RechargePage from './pages/RechargePage'
import LLMAdminPage from './pages/LLMAdminPage'
import SearchAdminPage from './pages/SearchAdminPage'
import SafeguardAdminPage from './pages/SafeguardAdminPage'
import AdminLoginPage from './pages/AdminLoginPage'
import ProtectedRoute from './components/auth/ProtectedRoute'
import AdminRoute from './components/auth/AdminRoute'
import { useAuthStore } from './store/authStore'
import { TextSelectionPopup } from './components/common/TextSelectionPopup'

function App(): JSX.Element {
  const initialize = useAuthStore((state) => state.initialize)

  // 初始化认证状态（优化：添加空依赖数组，确保只执行一次）
  useEffect(() => {
    initialize()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <BrowserRouter>
      <div className="bg-white" style={{ minHeight: '100vh' }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          {/* 管理后台 - 独立认证 */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route element={<AdminRoute />}>
            <Route path="/admin/llm" element={<LLMAdminPage />} />
            <Route path="/admin/search" element={<SearchAdminPage />} />
            <Route path="/admin/safe" element={<SafeguardAdminPage />} />
          </Route>
          {/* 受保护的路由 - 需要登录才能访问 */}
          <Route element={<ProtectedRoute />}>
            <Route path="/author-center" element={<AuthorCenter />} />
            <Route path="/agents" element={<AgentsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/memory" element={<UserMemoryPage />} />
            <Route path="/skills-documents" element={<SkillDocumentPage />} />
            <Route path="/recharge" element={<RechargePage />} />
            <Route path="/workspace/:id" element={<WorkspacePage />} />
            <Route path="/workspace/:id/agent-team" element={<AgentTeamPage />} />
          </Route>
        </Routes>
        {/* 全局文字选中快捷菜单 */}
        <TextSelectionPopup />
      </div>
    </BrowserRouter>
  )
}

export default App